import { render, staticRenderFns } from "./showCultivationInformation.vue?vue&type=template&id=261c60ad&"
import script from "./showCultivationInformation.vue?vue&type=script&lang=js&"
export * from "./showCultivationInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports